import {Link, useParams} from "react-router-dom";
import Button from "../../../components/UI/Button";
import {checkFeatureAvailability} from "../../../util/helper";
import {useSelector} from "react-redux";

const OrderFormSubmitBtn = ({isloading, order}) => {
  const params = useParams()
  const {orderForm} = useSelector(state => state.orders)
  return (
    <>
      <div className="row mt_10">
        <div className="col_12">
          <div className="d_flex_btwn">
            <Button
              text="Save"
              isPending={isloading}
              disabled={!checkFeatureAvailability(orderForm, 'default', params) ? true : false}
              classes={'btn btn_black pt_10 pb_10 pl_30 pr_30 font_16p width_full'}
              type={"submit"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderFormSubmitBtn